(function ($) {
  var form = $('#trailer-rental form');
  var block = $('.date-field');
  var dateInput = block.find('input');

  var available = form.length;

  var dpOptions = $.extend({}, {
    numberOfMonths: 2,
    minDate: '1d',
    maxDate: '333d',
    dateFormat: 'dd.mm.yy'
  });

  /*
    Nastavi datepicker
  */
  if (available)
    dateInput.map(function(s){
      $(this).addClass(`date_picker date-${s}`);
      $('<div class="input-addon open-datepicker"/>')
      .click(() => $(this).datepicker('show')).appendTo(block[s]);
      $(this).datepicker(dpOptions);
    });

})(jQuery);